module.exports = __webpack_public_path__ + "img/Bodice-Front-model up and bottom with3300.8d4bf45e.png";